var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-with-select"},[_c('div',{staticClass:"select-area"},[_c('div',{staticClass:"title-label"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"label-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"select-item"},[_vm._t("select")],2)]),_c('div',{staticClass:"text-area"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }